import React from "react";
import UseGetDashBoardData from "../../../../../Components/Hooks/useDashboardData";
import { ModernStatWidget } from "../../Components/DashboardCard";

function QuoteSubmmitted() {
  const { data } = UseGetDashBoardData(`/dashboard/quoteComparison`);
  const percentage = parseFloat(data?.current_month_count) || 0;
  const isNegative = percentage < 0;

  const QuoteIcon = (
    <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
  );

  return (
    <ModernStatWidget
      title="Quotes Sent to Customer"
      value={data?.total_count || 0}
      percentage={percentage}
      isNegative={isNegative}
      icon={QuoteIcon}
      bgColor="bg-purple-500/10"
      iconColor="text-purple-600"
      badgeLabel="this month"
    />
  );
}

export default QuoteSubmmitted;
